export const LOGO_SIZES = {
    catLogo: { height: 32, width: 58 },
    dealerLogo: { height: 40, width: 162 }
};
export const CATCORP_LOGO_ALT_TEXT = 'Caterpillar';
export const ENTER_KEY = 'Enter';
export const CAT_POI_ICON = 'https://caterpillar.scene7.com/is/content/Caterpillar/CM20230710-8878b-1472e?wid=38&hei=44&fmt=png-alpha';
export const MAIN_CAT_HEADER_ID = 'main-cat-header';
export const MAIN_CAT_HEADER_ID_MOBILE = 'main-cat-header-mobile';
